
import Vue from 'vue'
import ActionCard from '@/domains/global/components/ActionCard.vue'
import { Invoice } from '@/domains/global/models'

export default Vue.extend({
  components: { ActionCard },
  props: {
    inactive: { type: Boolean, default: false },
    invoice: { type: Object as () => Invoice | null, default: () => {} },
    isLoading: { type: Boolean, default: false },
    isPendingReview: { type: Boolean, default: false }
  },
  computed: {
    title(): string {
      return this.invoice ? `${this.invoice.type === 'correction' ? 'Review ' : ''} Cost Summary` : 'Review Cost Summary'
    },
    subtitle(): string {
      if (!this.invoice) {
        return ''
      }
      switch (this.invoice.status) {
        case 'paid':
          return 'Payment complete'
        case 'refunded':
          return 'Payment refunded'
        default:
          return ''
      }
    }
  }
})
